// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3198":"50b288af","5319":"4e3c083c"}[chunkId] + ".chunk.css";
};